import React from "react";

const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as
  | string
  | undefined;

export const PaymentTestModeBanner: React.FC = () => {
  // Banner intentionally suppressed — this is an internal-use app and the
  // test-mode notice was confusing for live walkthroughs. Re-enable by
  // restoring the previous render branches if a public payments flow is
  // added later.
  return null;
};

export default PaymentTestModeBanner;
